import { render, staticRenderFns } from "./ApruveAccountView.vue?vue&type=template&id=cfa01212&scoped=true&"
import script from "./ApruveAccountView.vue?vue&type=script&lang=js&"
export * from "./ApruveAccountView.vue?vue&type=script&lang=js&"
import style0 from "./ApruveAccountView.vue?vue&type=style&index=0&id=cfa01212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa01212",
  null
  
)

export default component.exports